import { ContentModel } from "../models/content.model";

// Durstenfeld shuffle
export function shuffleContents<T>(contentArray: ContentModel<T>[] | []): void {
  for (let i = contentArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [contentArray[i], contentArray[j]] = [contentArray[j], contentArray[i]];
  }
}
